import State from '@/state/State';
import { TODO_ACTIONS } from '@/utils/Todo';

export const NAME_REGEX = /^[a-zA-ZÀ-ÿ0-9 .\-/&'‘’]+$/;

const MAX_SALARY = 500000;
const MAX_WAGERATE = 99.99;

export const SALARY_VALIDATION_RULES = {
  required: true,
  min_value: 0,
  max_value: MAX_SALARY,
};

export const WAGERATE_VALIDATION_RULES = {
  required: true,
  min_value: 0,
  max_value: MAX_WAGERATE,
};

export const EMPLOYEE_STATE = {
  NEW: 'NEW',
  INSTALLED: 'INSTALLED',
  PENDING: 'PENDING',
  ENROLLING: 'ENROLLING',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  OPTOUT: 'OPTED OUT',
  DISABLED: 'DISABLED',
  OPTOUTPENDING: 'OPT OUT PENDING',
};

export const EMPLOYEE_PAY_TYPE = {
  HOURLY: 'hourly',
  SALARY: 'salary',
};

const NEW_EMPLOYEE_STATE = [EMPLOYEE_STATE.NEW, EMPLOYEE_STATE.INSTALLED];

const PENDING_EMPLOYEE_STATE = [EMPLOYEE_STATE.PENDING];

const ENROLLED_EMPLOYEE_STATE = [EMPLOYEE_STATE.ENROLLING, EMPLOYEE_STATE.ENROLLED, EMPLOYEE_STATE.ACTIVE];

const DISABLED_EMPLOYEE_STATE = [EMPLOYEE_STATE.DISABLED, EMPLOYEE_STATE.OPTOUT];

export const isNewEmployee = employee => NEW_EMPLOYEE_STATE.includes(employee.current_state);

export const isPendingEmployee = employee => PENDING_EMPLOYEE_STATE.includes(employee.current_state);

export const isEnrolledEmployee = employee => ENROLLED_EMPLOYEE_STATE.includes(employee.current_state);

export const isDisabledEmployee = employee => DISABLED_EMPLOYEE_STATE.includes(employee.current_state);

export const isEligibleEmployee = employee => !DISABLED_EMPLOYEE_STATE.includes(employee.current_state);

export const isSalariedEmployee = employee => employee.salary_properties.salary_or_hourly === EMPLOYEE_PAY_TYPE.SALARY;

export const isCompletedOptOutEmployee = employee =>
  DISABLED_EMPLOYEE_STATE.includes(employee.current_state) && employee.properties?.optout_completed_at;

export const canCompleteOptOut = employee =>
  State.state.todos.some(todo => todo.action === TODO_ACTIONS.DISABLE_EMPLOYEE && todo.fk === employee.employee_id);

export const getStateCounts = enrolmentSnapshot => {
  const snapshot = {};
  snapshot['ELIGIBLE'] = State.state.company.properties.headcount || enrolmentSnapshot.eligible || 0;
  snapshot[EMPLOYEE_STATE.ENROLLING] = enrolmentSnapshot.enrolling + enrolmentSnapshot.pending || 0;
  snapshot[EMPLOYEE_STATE.ENROLLED] = enrolmentSnapshot.adopted || 0;
  snapshot[EMPLOYEE_STATE.NEW] =
    (State.state.company.properties.headcount
      ? State.state.company.properties.headcount - (snapshot.ENROLLING + snapshot.ENROLLED)
      : enrolmentSnapshot.new) || 0;
  return snapshot;
};

export const convertStatus = employee => {
  if (employee.current_state === 'DISABLED' && employee.properties?.optout_initiated_at) {
    if (!employee.properties?.optout_completed_at) {
      return 'OPT OUT PENDING';
    } else if (employee.terminated_at) {
      return 'LEAVER';
    } else {
      return 'OPTED OUT';
    }
  }

  if (employee.current_state === 'DISABLED' && employee.terminated_at) {
    return 'LEAVER';
  }

  if (employee.properties?.paused && employee.current_state !== 'DISABLED') {
    return 'PAUSED';
  }

  const convertedStatuses = {
    // the employee has not yet signed up, nothing happening yet, NOT YET ACTIVE
    NEW: 'NOT ENROLLED',
    INSTALLED: 'NOT ENROLLED',
    // the employee uses the app, USING
    ACTIVE: 'ENROLLED',
    ENROLLED: 'ENROLLED',
    // the employee is in the process of activating and using the app, ONBOARDING
    ENROLLING: 'ENROLLING',
    PENDING: 'ENROLLING',
    // for some reason the employee is not using the app, DISABLED
    FURLOUGH: 'DISABLED',
    OPTOUT: 'OPTED OUT',
    OPTOUTPENDING: 'DISABLED',
    PAUSED: 'PAUSED',
    DISABLED: 'DISABLED',
  };

  return convertedStatuses[employee.current_state] || 'NO STATUS';
};
